import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import { ResultOperation, Column, SelfTableList, FilterState, ListFields, usePermission, useTranslation } from '@np/np_webcomponentlib'
import { API_BUSINESS } from '../../shared/consts/api'

import { DataEntityType, initEntity, columnsForChoose, DataEntityTypeViewModel } from './DRRateComissionTypes'

import { DRRateComissionFrom } from './DRRateComissionForm'

import { ColumnEvent, ColumnWithCopyToClipboard, ColumnData, DeleteEntity, DeleteEntityNew } from '../../shared/entityOperations/EntityOperationsCustomFC'

import '../../shared/entityOperations/EntityOperations.css'




const DRRateComissionList = ({ listFilterFieldProps }: { listFilterFieldProps: ListFields[] }) => {

  const { canView, canCreate, canUpdate, canRemove, debugMode } = usePermission('SpecificationcharacteristictypeList');

  const [initialFilter, setInitialFilter] = useState<FilterState>({
    listFields: listFilterFieldProps,
    sort: null,
    searchData: '',
    take: 50,
    skip: 0,
  })

  const [idEdit, setIDEdit] = useState<string>("")

  const [forceUpdate, setForceUpdate] = useState<boolean>(false)

  const [show2, setShow2] = useState(false);
  const xtralargemodalClose = () => { setIDEdit(""); setShow2(false) };
  const xtralargemodalShow = () => setShow2(true);


  const dateAddedTitle = useTranslation('dateAdded');
  const dateUpdatedTitle = useTranslation('dateUpdated');

  const idrfSpecificationTitle = useTranslation('idrfSpecification');
  const idrfCharacteristicTypeTitle = useTranslation('idrfCharacteristicType');
  const isMandatoryTitle = useTranslation('isMandatory');


  useEffect(()=>{
    setInitialFilter({
      listFields: listFilterFieldProps,
      sort: null,
      searchData: '',
      take: 50,
      skip: 0
  })
  },[listFilterFieldProps])


  const memoizedColumnsSpecificationcharacteristictype = useCallback(() => {
    const columnsSpecificationcharacteristictype: Column[] = [

      

      {
        title: '',
        listFields: null,
        type: 'custom',
        custom: (data: DataEntityType) => (

          <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
        ),
        key: 1,
        withFilter: null,
        class: "eventColumn"
      },

      {
        title: '',
        listFields: null,
        type: 'custom',
        custom: (data: DataEntityType) => (

          <ColumnEvent idUnique={data.idUnique} event={handleEdit} title='fe fe-edit eventIcom'></ColumnEvent>
        ),
        key: 2,
        withFilter: null,
        class: "eventColumn"
      },

      {
        title: dateAddedTitle,
        listFields: {
          fieldName: 'dateAdded',
          comparison: 'containsStrong',
          listVal: [''],
        },
        type: 'date-time',
        key: 100,
        withFilter: 'onlySorted',
        class: "dateTtimeColumn"
      },



      {
        title: 'Тип платежа',
        listFields: {
            fieldName: 'typeOperation',
            comparison: 'containsIgnoreCase',
            listVal: [''],
        },
        key: 9,
        withFilter: 'all',
    },


    {
      title: 'Метод платежа',
      listFields: {
          fieldName: 'paymentMethod',
          comparison: 'containsIgnoreCase',
          listVal: [''],
      },
      key: 11,
      withFilter: 'all',
  },


  {
    title: 'Банк',
    listFields: {
        fieldName: 'bank',
        comparison: 'containsIgnoreCase',
        listVal: [''],
    },
    key: 15,
    withFilter: null
},


  {
          title: 'Значения',
          listFields: null,
          type: 'custom',
          custom: (data: DataEntityType) => (

            <>
            <table>
              <tr>
                <td>Процент комиссии</td>
                <td>{data.comissionPercent}</td>
              </tr>

              {/* <tr>
                <td>Минимальаня комиссия</td>
                <td>{data.minimumComission}</td>
              </tr> */}

              <tr>
                <td>Мин. платеж</td>
                <td>{data.minAmountPayment.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</td>
              </tr>

              <tr>
                <td>Макс. платеж</td>
                <td>{data.maxAmountPayment.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</td>
              </tr>

            </table>
            </>
            
          ),
          key: 132,
          minWidthValue: 150,
          withFilter: null
        }

,
        {
          title: dateUpdatedTitle,
          listFields: {
            fieldName: 'dateUpdated',
            comparison: 'containsStrong',
            listVal: [''],
          },
          type: 'date-time',
          key: 101,
          withFilter: 'onlySorted',
          class: "dateTtimeColumn"
        }
    ]
  

    if (debugMode || canRemove) {
      columnsSpecificationcharacteristictype.push(
        {
          title: '',
          listFields: null,
          type: 'custom',
          custom: (data: DataEntityType) => (

            <DeleteEntityNew idUnique={data.idUnique} apiPath={`${API_BUSINESS}/drratecomission`} onResult={onResultRemove}></DeleteEntityNew>
          ),
          key: 102,
          withFilter: null,
          class: "eventColumn"
        })
    }
    return columnsSpecificationcharacteristictype
  }, [idrfSpecificationTitle, idrfCharacteristicTypeTitle, isMandatoryTitle, dateAddedTitle, dateUpdatedTitle, debugMode, canRemove])


  const handleEdit = (idUnigue: string) => {
    setIDEdit(idUnigue)
  }

  const onResultRemove = (result: ResultOperation) => {
    if (result.status === "success") {

      setForceUpdate(true)

      console.log("forceUpdate:", forceUpdate)
    }
  }

  useEffect(() => {
    if (forceUpdate) {
      setForceUpdate(false)
    }
  }, [forceUpdate])


  useEffect(() => {
    if (idEdit !== "") {
      xtralargemodalShow()
    }
  }, [idEdit])

  const getTitleModal = () => {
    if (idEdit === "")
      return "Создание"
    else
      return "Редактирование"
  }



  const docClientForm = useMemo(() => (
    <DRRateComissionFrom 
      title={getTitleModal()} 
      idInit={idEdit} 
      handleClose={xtralargemodalClose} 
      initEntityProps={listFilterFieldProps.length > 0 ? { ...initEntity, idrfRate: listFilterFieldProps[0].listVal[0] } : initEntity}
    />
  ), [show2]);

  return (
    <Fragment>

      {canCreate &&
        <Button variant="primary" onClick={xtralargemodalShow}><i className='fa fa-plus'></i>
        </Button>
      }

      <Modal size="xl" show={show2} onHide={xtralargemodalClose}>
        <ModalHeader>
          <ModalTitle as="h5"></ModalTitle>
          <span className="d-flex ms-auto" onClick={xtralargemodalClose}><i className='fe fe-x ms-auto' ></i></span>
        </ModalHeader>
        <ModalBody>
          {/* <DocClientForm title={getTitleModal()} idInit={idEdit} handleClose={xtralargemodalClose} initEntityProps={listFilterFieldProps.length > 0 ? { ...initEntity, idClient: listFilterFieldProps[0].listVal[0] } : initEntity}></DocClientForm> */}
          {docClientForm}
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={xtralargemodalClose}>
            Закрыть
          </Button>
        </ModalFooter>
      </Modal>

      {/* {show2 && <SessionForm title={"Создание/Редактирование"} idInit={null}></SessionForm>} */}


      {!show2 && listFilterFieldProps.length > 0 && initialFilter.listFields[0].listVal[0] !== "" &&  <SelfTableList apiUrl={`${API_BUSINESS}drratecomission/list`} columns={memoizedColumnsSpecificationcharacteristictype()} classProp='table table-striped' theadClassProp='table' forceUpdate={forceUpdate} initialFilterState={initialFilter} />}
      {!show2 && listFilterFieldProps.length == 0 && <SelfTableList apiUrl={`${API_BUSINESS}drratecomission/list`} columns={memoizedColumnsSpecificationcharacteristictype()} classProp='table table-striped' theadClassProp='table' forceUpdate={forceUpdate} />}
    </Fragment>
  )
}


export default DRRateComissionList